import { FC } from 'react'
import type { AwardsModuleHomePage } from '../../../types/components'
import ModuleAwardsHomePageComponent from '../ModuleHomepage'
import { ApiPagePage } from '../../../types/contentTypes'

const ModuleAwardsHomePage: FC<{
  moduleProps: AwardsModuleHomePage['attributes']
  landingContentData: ApiPagePage['attributes']
}> = ({ moduleProps }) => {
  return <ModuleAwardsHomePageComponent moduleProps={moduleProps} />
}

export default ModuleAwardsHomePage
